import styled, { css } from 'styled-components';
import Typography from '../Typography';
export const HeaderStyleCSS = css `
  margin-top: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
export default styled(Typography) `
  ${HeaderStyleCSS}
`;
//# sourceMappingURL=HeadingStyle.js.map